import { useContext } from 'react';

import { pattern } from '@endurancewarranty/lib';
import { UserContext } from '@lib/auth/UserContextProvider';
import { UserRoleKeyEnum } from '@lib/enums';
import { hasAnyRole } from '@lib/utils/hasAnyRole';

import type { TUser } from '@models/authorization/TUser';

const { isMatching, P } = pattern;

export type TUseCurrentUser = Readonly<{
  user: TUser;
  isCustomerService: boolean;
  isRetention: boolean;
  isBilling: boolean;
}>;

export function useCurrentUser(): TUseCurrentUser {
  const ctx = useContext(UserContext);

  if (ctx == null) {
    throw new Error('useCurrentUser must be used within UserContextProvider');
  }

  const { user } = ctx;

  const isBilling = user.roles.some(isMatching({ roleKey: P.string.startsWith('billing') }));

  const isCustomerService = hasAnyRole(user.roles, [UserRoleKeyEnum.CustomerService]);

  const isRetention = hasAnyRole(user.roles, [
    UserRoleKeyEnum.RetentionAgent,
    UserRoleKeyEnum.RetentionManager,
  ]);

  return {
    user,
    isCustomerService,
    isRetention,
    isBilling,
  };
}
